import * as Yup from "yup";

//  validations schemas
const validationSchema = Yup.object().shape({
  email: Yup.string()
    .email("Invalid email address")
    .required("Email is required*"),
  password: Yup.string()
    .trim()
    .matches(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/,
      "Password must contain at least one uppercase letter, one lowercase letter, one number, and one special character."
    )
    .required("Password is required*"),
});

const forgotPasswordValidationSchema = Yup.object().shape({
  email: Yup.string()
    .email("Invalid email address*")
    .required("Email is required*"),
});
const resetPasswordValidationSchema = Yup.object().shape({
  password: Yup.string()
    .trim()
    .matches(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/,
      "Password must contain at least one uppercase letter, one lowercase letter, one number, and one special character."
    )
    .required("Password is required*"),
  confirmPassword: Yup.string()
    .trim()
    .oneOf([Yup.ref("password")], "Password must match*")
    .required("Confirm your password*"),
});
const changePasswordValidationSchema = Yup.object().shape({
  oldPassword: Yup.string().trim().required("Old Password is required*"),
  password: Yup.string()
    .trim()
    .matches(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/,
      "Password must contain at least one uppercase letter, one lowercase letter, one number, and one special character."
    )
    .required("Password is required*"),
  confirmPassword: Yup.string()
    .trim()
    .oneOf([Yup.ref("password")], "Password must match*")
    .required("Confirm your password*"),
});
const profileValidationSchema = Yup.object().shape({
  profileImage: Yup.string().trim(),
  firstName: Yup.string().trim().required("First name is required*"),
  lastName: Yup.string().trim().required("Last name is required*"),
  emailAddress: Yup.string().trim().required("Email address is required*"),
  phoneNumber: Yup.string().trim().required("Phone number is required*"),
  location: Yup.string().trim().required("Location is required*"),
});

const growerValidationSchema = Yup.object().shape({
  email: Yup.string().email("Invalid email").required("Email is required*"),

  firstName: Yup.string().trim().required("First name is required*"),

  lastName: Yup.string().trim().required("Last name is required*"),

  countryCode: Yup.string(),

  phoneNumber: Yup.string()
    .trim()
    // .min(10, "Invalid number")
    .required("Phone number is required*"),

  address: Yup.string().trim().required("Address is required*"),
});

const fieldValidationSchema = Yup.object().shape({
  fieldName: Yup.string().required("Field Name is required"),
  acres: Yup.string().required("Acres is required"),
  LLD: Yup.array().of(Yup.string()),
  notes: Yup.string().nullable(),
  cropId: Yup.object().shape().nullable(),
  SubFields: Yup.array().of(
    Yup.object().shape({
      name: Yup.string().required("Sub Field Name is required"),
      cropId: Yup.object()
        .shape({
          id: Yup.string(),
          value: Yup.string(),
          label: Yup.string(),
        })
        .nullable()
        .required("Crop is required"),
    })
  ),
});

const scoutingValidationSchema = Yup.object().shape({
  scoutTime: Yup.string(),
  mixSheetFile: Yup.string(),
});
const cropPlanValidationSchema = Yup.object().shape({
  soilTest: Yup.object({
    N: Yup.string(),
    P: Yup.string(),
    K: Yup.string(),
    S: Yup.string(),
  }),
  seed: Yup.object({
    variety: Yup.string(),
    rate: Yup.string(),
    unit: Yup.string(),
    quantity: Yup.string(),
  }),
});

const addProductValidationSchema = Yup.object().shape({
  productName: Yup.string().trim().required("Product name is required*"),
  rate: Yup.string().trim().required("Rate is required*"),
  notes: Yup.string().trim(),
});

// add new ------

// const addCropPlanValidationSchema = Yup.object().shape({
//   growingSeason: Yup.string().trim().required("Growing season is required*"),
//   description: Yup.string().trim(),
//   planStatus: Yup.string().trim(),
// });
const addCropPlanValidationSchema = (existingYears = []) =>
  Yup.object().shape({
    growingSeason: Yup.string().required("Growing season is required"),
    description: Yup.string().trim(),
    planStatus: Yup.string().trim(),
  });
const addCropValidationSchema = Yup.object().shape({
  cropId: Yup.string().required("Crop is required*"),
  variety: Yup.string().trim(),
  acres: Yup.string().trim(),
  acresValue: Yup.string()
    .trim()
    .when("acres", {
      is: (acres) => acres === "Values",
      then: (schema) => schema.required("Acres value is required*"),
      otherwise: (schema) => schema,
    }),
  description: Yup.string().trim(),
});
const CropValidationSchema = Yup.object().shape({
  cropId: Yup.string().required("Crop is required*"),
  cropName: Yup.string().required("CropName is required*"),
});
const yearValidationSchema = Yup.object().shape({
  seasonId: Yup.string().required("year is required*"),
  year: Yup.string().required("year is required*"),
});

export {
  validationSchema,
  growerValidationSchema,
  forgotPasswordValidationSchema,
  resetPasswordValidationSchema,
  changePasswordValidationSchema,
  profileValidationSchema,
  fieldValidationSchema,
  scoutingValidationSchema,
  cropPlanValidationSchema,
  addProductValidationSchema,
  addCropValidationSchema,
  addCropPlanValidationSchema,
  CropValidationSchema,
  yearValidationSchema,
};
